import { Button, type ButtonProps } from '@mui/material'
import { createLink, type LinkComponent } from '@tanstack/react-router'
import { forwardRef } from 'react'

const MuiButtonAnchor = forwardRef<HTMLAnchorElement, ButtonProps<'a'>>(
  function MuiButtonAnchor(props, ref) {
    return <Button ref={ref} component="a" {...props} />
  },
)

const CreatedButtonLink = createLink(MuiButtonAnchor)

/** Botão do MUI que navega pelo roteador, com `to` e `params` tipados. */
export const ButtonLink: LinkComponent<typeof MuiButtonAnchor> = (props) => (
  <CreatedButtonLink preload="intent" {...props} />
)
